var exports = {
  "l": "reason__dTEfe6",
};

module.exports = exports;
